import { Button } from "@grupoboticario/flora-react";
import { DynamicModulesContext } from "../../contexts/DynamicModuleProvider";
import { useContext } from "react";
import { NavLink, useHistory } from "react-router-dom";
import { ReactComponent as LogoIcon } from "../../icons/svg/icon.svg";
import {
  BoxOptions,
  NotFoundBox,
  NotFoundDescription,
  NotFoundTitle,
} from "./style";
import Loading from "../../components/Loading";


export function PageNotFound() {

  let history = useHistory();
  
  const dynamicModulesContext = useContext(DynamicModulesContext);
  return (
    dynamicModulesContext.length ?
    <>
      <NotFoundBox>
        <LogoIcon style={{ width: "60px", height: "auto" }} />
        <br />
        <NotFoundTitle>Ops...</NotFoundTitle>
        <NotFoundDescription>
          Identificamos que você ainda não possui acesso à este módulo.
        </NotFoundDescription>
        <NotFoundDescription>
          Entre em contato com o Executivo responsável por atendê-lo e solicite
          seu acesso.
        </NotFoundDescription>
        <BoxOptions>
          <Button onClick={history.goBack} size={"small"}>
            Voltar a página anterior
          </Button>
          <NavLink exact to="/" style={{ textDecoration: "none", outline: "none" }}>
            <Button size={"small"}>Ir a página inícial</Button>
          </NavLink>
        </BoxOptions>
      </NotFoundBox>
    </> : <Loading />
  );
}